export enum ModalType {
    SEARCH = <any>'S',
    ADD = <any>'A'
}
